import * as React from 'react';
import { logError } from './logError';

type ComponentType = React.ComponentType<any>;

export const SafeComponent =
    (module: string, componentName: string) =>
    (Component: ComponentType): React.ComponentClass<any> =>
        class SafeComponent extends React.Component<any> {
            override componentDidCatch(err: Error): void {
                logError(err, { module, payload: { componentName } });
            }

            override render(): React.ReactNode {
                return React.createElement(Component, { ...(this as any).props });
            }
        };
